module.exports = __webpack_public_path__ + "media/Video 15.4bb79429.mp4";